import { ApiHandler } from '@eshop/api-client'

import type { SearchResult } from '#/local/service'

import { Config } from '#/global/helper/Config'

export type SearchEngineName = 'articles' | 'manufacturers' | 'nodes-eshop' | 'nodes-rental' | 'products-eshop' | 'products-rental'

interface SearchResponse {
    engine_name: SearchEngineName
    results: {
        id: string
        image: string
        item_name: string
        name_formatted: string
        slug: string
        url: string
    }[]
}

export const search = async (query: string, signal: AbortSignal) => {
    const shopId = Config.getShopId().replace('_', '-')

    const api = new ApiHandler<'/v2/{shopId}/autocomplete-search', SearchResponse[]>({
        apiEndpoint: 'search',
        path: '/v2/{shopId}/autocomplete-search',
        pathParameters: {
            shopId,
        },
        parameters: {
            query,
        },
        signal,
    })

    return (await api.send()) ?? []
}

export const itemClicked = async (query: string, item: SearchResult) => {
    const shopId = Config.getShopId().replace('_', '-')

    const api = new ApiHandler<'/v2/{shopId}/{type}/item-clicked', void>({
        apiEndpoint: 'search',
        path: '/v2/{shopId}/{type}/item-clicked',
        pathParameters: {
            shopId,
            type: item.type,
        },
        parameters: {
            query,
            item_id: item.id,
            autocomplete: 'true',
        },
        method: 'POST',
        silent: true,
    })

    return api.send()
}
